import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Trash from './icon-trash.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Trash {...validProps} />;
}
SvgComponent.iconName = 'trash';

/**
 * @deprecated This is a legacy icon
 */
export const TrashIcon = svgIconWrapper(SvgComponent);
